import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  FormLabelProps,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { FieldProps, getIn } from "formik";
import React from "react";

interface Props extends FieldProps {
  label: string;
  labelProps?: FormLabelProps;
  containerProps?: FormControlProps;
  rightElement?: React.ReactNode;
}

const ChakraInput: React.FC<Props> = ({
  field,
  form,
  label,
  labelProps,
  containerProps,
  rightElement,
  ...props
}) => {
  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  return (
    <FormControl isInvalid={!!errorText} my="2" {...containerProps}>
      <FormLabel
        fontFamily="Lexend, sans-serif"
        color="gray.700"
        htmlFor={`${field.name}-id`}
        {...labelProps}
      >
        {label}
      </FormLabel>
      {rightElement ? (
        <InputGroup>
          <Input id={`${field.name}-id`} shadow="sm" {...field} {...props} />
          <InputRightElement>{rightElement}</InputRightElement>
        </InputGroup>
      ) : (
        <Input id={`${field.name}-id`} shadow="sm" {...field} {...props} />
      )}
      <FormErrorMessage>{errorText}</FormErrorMessage>
    </FormControl>
  );
};

export default ChakraInput;
